const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: '/knowledge',
    translationKey: dummy_t('menu.knowledge'),
  },
  {
    externalPath: 'https://raize.zendesk.com/hc/en-us',
    translationKey: dummy_t('footer.contact'),
  },
];
